import React from 'react';
import DeleteAccountModal from 'shared/account-settings/components/delete-account-modal';
import Button from 'src/components/button';
import 'stylesheets/components/account-settings-form-footer.scss';

interface Props {
  deleteAccountText?: string;
  submitting?: boolean;
  includeDelete?: boolean;
  handleSubmit?: () => void;
  studentId?: string;
  disabled?: boolean;
}

const AccountSettingsFormFooter = ({
  deleteAccountText,
  submitting,
  includeDelete,
  handleSubmit,
  studentId,
  disabled,
}: Props) => (
  <div className="account-settings-form-footer">
    <div className="account-settings-form-footer-delete">
      {includeDelete && studentId && deleteAccountText && (
        <DeleteAccountModal areYouSureText={deleteAccountText} studentId={studentId} />
      )}
    </div>
    {handleSubmit && (
      <div className="account-settings-form-footer-save">
        <Button
          color="primary"
          type="submit"
          disabled={submitting || disabled}
          margin={false}
          buttonName="form-footer save"
          onClick={handleSubmit}
          size="medium"
          testId="account-settings-save-button"
        >
          {submitting ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
    )}
  </div>
);

export default AccountSettingsFormFooter;
